import { BaseButtons, BaseForm, BaseGridLayout, BaseTextInput, BaseTitolo,  BasePassword, ICONE, useRoutes} from '@lucan/base-ui';
import MessageBox from 'components/MessageBox';
import Loading from 'components/Loading';
import React, { useEffect, useRef, useState } from 'react';
import { useCheckUsername, useLogin } from 'services/Network';
import { Chip, Tooltip } from '@mui/material';


//import './../login.css';
//import { useUserContext } from '../services/UserContext';

const Login = ({app, app_key, onComplete}) => {

	const {
    inAttesaDelServer,
    invia
  } = useLogin({})
	  const { inAttesaDelServer: inAttesaStep1, invia: verificaUsername } = useCheckUsername({});
 	
	const { getPath } = useRoutes()
	const [step, setStep] = useState(1);
  const [username, setUsername] = useState('');
	const [stato, setStato] = useState('')
	const formRef = useRef()

	useEffect(() => {
   
      function keyboardListener(e) {
        if (e.key === 'Enter') formRef?.current?.submit()
      }

      window.addEventListener('keydown', keyboardListener)
      return () => window.removeEventListener('keydown', keyboardListener)
   
  }, [])
//


	async function eseguiTentativoLogin(credenziali) {
		const {myusername:username, connet:password} = credenziali;
		const { ok, data, error:errorRichiesta} = await invia(username, password, app_key)
		if (ok){
			if(data.esito){
				onComplete(data)
			}else{
				setStato(data.messaggi[0].msg ?? '')
			}				
		}else{
			setStato(errorRichiesta.message);
		}		 
  }

	 // Step 1: verifica username
  async function handleUsernameStep(credenziali) {
    const { myusername } = credenziali;
		
    const { ok, data, error: errorRichiesta } = await verificaUsername(myusername, app_key);
    
    if (ok) {
      if (data.redirect) {
        window.location.href = data.url; // redirect se richiesto dal backend
      } else {
        setUsername(myusername);
        setStep(2); // passa allo step password
      }
    } else {
      setStato(errorRichiesta?.message ?? 'Errore nel verificare username');
    }
  }
// Step 2: login con password
  async function handlePasswordStep(credenziali) {
    const { connet: password } = credenziali;
    const { ok, data, error: errorRichiesta } = await invia(username, password, app_key);

    if (ok) {
      if (data.esito) {
        onComplete(data);
      } else {
        setStato(data.messaggi[0]?.msg ?? '');
      }
    } else {
      setStato(errorRichiesta?.message);
    }
  }
 
	return(<>
			{app && <BaseTitolo><span style={{fontSize: '75%'}}>autenticazione per</span><br /><span className="titolo">{app}</span></BaseTitolo>}			
			<Loading loading={inAttesaDelServer} />
			{!inAttesaDelServer && stato && stato.length > 0 && <MessageBox  errorMsg={{main:stato}}/>}
			      {step === 1 && (
        <BaseForm formProps={{ autoComplete: 'off' }} onSubmit={handleUsernameStep} ref={formRef}>
          <BaseGridLayout vertical spacing={0}>
            <BaseTextInput label="Nome utente" name="myusername" autoFocus defaultValue="" required />
            <BaseButtons.Custom className="full" testo="Avanti" disabled={inAttesaStep1} submit/>
          </BaseGridLayout>
        </BaseForm>
      )}

      {step === 2 && (
        <BaseForm formProps={{ autoComplete: 'off' }} onSubmit={handlePasswordStep} ref={formRef}>
          <BaseGridLayout vertical spacing={0}>
						<Tooltip title={<span>Cambia utente</span>}><Chip icon={<ICONE.FACCIA />} sx={{mt:2}}variant="outlined" label={username} onClick={() => setStep(1)}/></Tooltip>
            <BasePassword
							autoFocus
              label="Password"
              name="connet"
              autoComplete="new-password"
              required
              defaultValue=""
            />
            <BaseButtons.Login className="full" disabled={inAttesaDelServer} submit />
          </BaseGridLayout>
        </BaseForm>
      )}
		</>)

}


export default Login;